<div #controlPanel>
    <ng-content></ng-content>
</div>
